import { createSlice } from '@reduxjs/toolkit'

export const modalSlice = createSlice({
    name: "modal",
    initialState: {
        isOpen: false,
        content: <></>
    },

    reducers: {
        showModal: (state, payload) => {
            state.isOpen = true
            state.content = payload.payload.content

        },
        closeModal: (state, payload) => {
            state.isOpen = false;
            state.content = <></>
        },

    }
});

export const { showModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;